export enum SocketEventNamespace {
  DEVICES = 'devices',
  INCIDENTS = 'incidents',
  WORKFLOW = 'workflow',
}
